export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos de la visita técnica"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a lista de visitas"])},
          "producer_code": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código"])}
        }
      }
    }
  })
}